// extracted by mini-css-extract-plugin
export var searchHeader = "_8s-0";
export var searchHeaderDark = "_8s-1";